import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateSimXInstitutionRequest } from '../models/requests/create-simx-institution-request.model';
import { GetSimXInstitutionRequest } from '../models/requests/get-simx-institution-request.model';
import { GetSimXInstitutionsRequest } from '../models/requests/get-simx-institutions-request.model';
import { UpdateSimXInstitutionRequest } from '../models/requests/update-simx-institution-request.model';
import { ActivateSimXInstitutionResponse } from '../models/responses/activate-simx-institution-response.model';
import { CreateSimXInstitutionResponse } from '../models/responses/create-simx-institution-response.model';
import { GetSimXInstitutionResponse } from '../models/responses/get-simx-institution-response.model';
import { GetSimXInstitutionsResponse } from '../models/responses/get-simx-institutions-response.model';
import { UpdateSimXInstitutionResponse } from '../models/responses/update-simx-institution-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class InstitutionDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getInstitutions(
    request: GetSimXInstitutionsRequest = {},
  ): Observable<GetSimXInstitutionsResponse> {
    const url = this._dataService.institutionsUrl();
    return this._http.post<GetSimXInstitutionsResponse>(url, request);
  }

  getInstitution(
    institutionId: string,
    request: GetSimXInstitutionRequest = {},
  ): Observable<GetSimXInstitutionResponse> {
    const url = this._dataService.institutionsUrl(institutionId);
    return this._http.post<GetSimXInstitutionResponse>(url, request);
  }

  createInstitution(
    request: CreateSimXInstitutionRequest,
  ): Observable<CreateSimXInstitutionResponse> {
    const url = this._dataService.institutionsUrl();
    return this._http.put<CreateSimXInstitutionResponse>(url, request);
  }

  updateInstitution(
    institutionId: string,
    request: UpdateSimXInstitutionRequest,
  ): Observable<UpdateSimXInstitutionResponse> {
    const url = this._dataService.institutionsUrl(institutionId);
    return this._http.patch<UpdateSimXInstitutionResponse>(url, request);
  }

  deleteInstitution(institutionId: string): Observable<void> {
    const url = this._dataService.institutionsUrl(institutionId);
    return this._http.delete<void>(url);
  }

  activateInstitution(
    institutionId: string,
  ): Observable<ActivateSimXInstitutionResponse> {
    const url = this._dataService.activateInstitutionUrl(institutionId);
    return this._http.patch<ActivateSimXInstitutionResponse>(url, {});
  }
}
